var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
      ],
      staticClass: "row",
      staticStyle: { "padding-top": "10px" },
    },
    [
      _c(
        "pui-form-group",
        {
          directives: [
            {
              name: "pui-form-grid-column",
              rawName: "v-pui-form-grid-column",
              value: { s: 12, m: 12, l: 12 },
              expression: "{ s: 12, m:12, l: 12 }",
            },
          ],
          staticClass: "unit_group",
          attrs: {
            label:
              _vm
                .$t("operationalData.entryView.unitGeneration.title")
                .toString()
                .toUpperCase() + " :",
            "has-label-padding": false,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
              ],
              staticClass: "row",
            },
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitGeneration.electricGrossGeneration"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      precision: _vm.precision,
                      "is-disabled": _vm.isReaderUser,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange(
                          $event,
                          "GeneratedPowerGrossMwh"
                        )
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.GeneratedPowerGrossMwh,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel,
                          "GeneratedPowerGrossMwh",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.GeneratedPowerGrossMwh",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitGeneration.electricNetGeneration"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      precision: _vm.precision,
                      "is-disabled": _vm.isReaderUser,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange($event, "GeneratedPowerMwh")
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.GeneratedPowerMwh,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel,
                          "GeneratedPowerMwh",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.GeneratedPowerMwh",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitGeneration.gridFeed"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      precision: _vm.precision,
                      "is-disabled": _vm.isReaderUser,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange($event, "GridFeedVolumeMwh")
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.GridFeedVolumeMwh,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel,
                          "GridFeedVolumeMwh",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.GridFeedVolumeMwh",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
              ],
              staticClass: "row",
            },
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitGeneration.grossHeatGeneration"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      precision: _vm.precision,
                      "is-disabled": true,
                    },
                    model: {
                      value: _vm.thermalHeatSums.Gross,
                      callback: function ($$v) {
                        _vm.$set(_vm.thermalHeatSums, "Gross", _vm._n($$v))
                      },
                      expression: "thermalHeatSums.Gross",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitGeneration.netHeatGeneration"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      precision: _vm.precision,
                      "is-disabled": true,
                    },
                    model: {
                      value: _vm.thermalHeatSums.Net,
                      callback: function ($$v) {
                        _vm.$set(_vm.thermalHeatSums, "Net", _vm._n($$v))
                      },
                      expression: "thermalHeatSums.Net",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitGeneration.electricalEquivalentOfNetHeatGeneration"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      precision: _vm.precision,
                      "is-disabled": true,
                    },
                    model: {
                      value: _vm.thermalHeatSums.ElectricEquivalentOfNet,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.thermalHeatSums,
                          "ElectricEquivalentOfNet",
                          _vm._n($$v)
                        )
                      },
                      expression: "thermalHeatSums.ElectricEquivalentOfNet",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
              ],
              staticClass: "row",
            },
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitGeneration.netMWhForPeriod"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: _vm.required,
                      precision: _vm.precision,
                      "is-disabled": true,
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.NetVolumeForPeriodMwh,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel,
                          "NetVolumeForPeriodMwh",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.NetVolumeForPeriodMwh",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitGeneration.auxiliaryConsumption"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: false,
                      precision: _vm.precision,
                      "is-disabled": _vm.isReaderUser,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange($event, "AuxiliaryConsumption")
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.AuxiliaryConsumption,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel,
                          "AuxiliaryConsumption",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.AuxiliaryConsumption",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: {
                    label: _vm.$t(
                      "operationalData.entryView.unitGeneration.auxiliaryPowerOnShutdown"
                    ),
                  },
                },
                [
                  _c("custom-input", {
                    attrs: {
                      min: _vm.min,
                      required: false,
                      precision: _vm.precision,
                      "is-disabled": _vm.isReaderUser,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onInputChange(
                          $event,
                          "AuxiliaryPowerOnShutdown"
                        )
                      },
                    },
                    model: {
                      value: _vm.activeUnitKPIModel.AuxiliaryPowerOnShutdown,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.activeUnitKPIModel,
                          "AuxiliaryPowerOnShutdown",
                          _vm._n($$v)
                        )
                      },
                      expression: "activeUnitKPIModel.AuxiliaryPowerOnShutdown",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }